export default "__VITE_ASSET__583fcb7d__"